export default "__VITE_ASSET__C_19UDUk__"